import { Alert } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import React from 'react';
import { messageReviewLibraryEntryActionAtom } from '../../../atoms/messages';

export function ReviewLibraryEntryMessages() {
  const reviewLibraryEntryMessage = useAtomValue(
    messageReviewLibraryEntryActionAtom,
  );

  return reviewLibraryEntryMessage ? (
    <Alert type={reviewLibraryEntryMessage.type}>
      {reviewLibraryEntryMessage.text}
    </Alert>
  ) : null;
}

ReviewLibraryEntryMessages.propTypes = {};

export default { ReviewLibraryEntryMessages };
